import { BaseApi } from '@/main/baseApi';

import { MODULE_API, NAME, ND_OBJEDNAVKA } from './constants';

export const apiProvider = new BaseApi(MODULE_API, ND_OBJEDNAVKA, NAME);
